import { Controller } from "@hotwired/stimulus"
import { AreaSeries, createChart } from "lightweight-charts"

const BRAND = {
  yellow: "#EAB308",
  dark: "#171717",
  white: "#FAFAFA",
}

const COLORS = {
  chartBackground: BRAND.white,
  text: BRAND.dark,
  grid: "rgba(23, 23, 23, 0.08)",
  border: "rgba(23, 23, 23, 0.18)",
  crosshairLine: "rgba(234, 179, 8, 0.55)",

  marginLine: "rgb(168, 85, 247)",
}

export default class extends Controller {
  static targets = ["container"]
  static values = {
    series: Array,
  }

  connect() {
    if (!document.getElementById("hide-tv-attr-logo")) {
      const style = document.createElement("style")
      style.id = "hide-tv-attr-logo"
      style.textContent = "#tv-attr-logo { display: none !important; }"
      document.head.appendChild(style)
    }
    const data = Array.isArray(this.seriesValue) ? this.seriesValue : []
    if (!this.hasContainerTarget) return

    this.chart = createChart(this.containerTarget, {
      autoSize: true,
      layout: {
        background: { type: "solid", color: COLORS.chartBackground },
        textColor: COLORS.text,
      },
      grid: {
        vertLines: { color: COLORS.grid },
        horzLines: { color: COLORS.grid },
      },
      rightPriceScale: {
        borderColor: COLORS.border,
        textColor: COLORS.text,
        scaleMargins: { top: 0.12, bottom: 0.18 },
      },
      timeScale: { borderColor: COLORS.border },
      crosshair: {
        vertLine: { color: COLORS.crosshairLine },
        horzLine: { color: COLORS.crosshairLine },
      },
    })

    // Filled area to match the newer chart styling.
    this.series = this.chart.addSeries(AreaSeries, {
      lineColor: COLORS.marginLine,
      topColor: "rgba(168, 85, 247, 0.20)",
      bottomColor: "rgba(168, 85, 247, 0.02)",
      lineWidth: 2,
      priceLineVisible: false,
      crosshairMarkerVisible: true,
      crosshairMarkerRadius: 4,
      crosshairMarkerBackgroundColor: "#FFFFFF",
      crosshairMarkerBorderColor: COLORS.marginLine,
      priceFormat: {
        type: "custom",
        minMove: 0.01,
        formatter: (p) => `${Number(p).toFixed(2)}%`,
      },
    })

    this.series.setData(data)

    requestAnimationFrame(() => {
      if (this.chart) this.chart.timeScale().fitContent()
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.remove()
      this.chart = null
    }
  }
}


